<template>
  <b-modal
    id="airdrop-event-win-modal"
    dialog-class="airdrop-event-win-modal"
    hide-header
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    hide-footer
    centered
  >
    <div id="airdrop-event-win">
      <img class="fireworks" :src="`${$s3}/img/common/event/airdrop/airdrop-background.webp?${$ver}`" />
      <img class="winner" :src="`${$s3}/img/${lang}/event/airdrop/win.webp?${$ver}`" />
      <button class="go-to-regist" @click="submitWallet">
        {{ lang === 'ko' ? '지갑 주소 제출 하기' : 'Submit wallet address' }}
      </button>
    </div>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'win-modal',
  props: ['openSubmitModal'],
  computed: {
    ...mapState(['lang', 'isMobile']),
  },
  methods: {
    goToEventPage() {
      this.$bvModal.hide('airdrop-event-win-modal');
      this.$router.push({ name: 'AirDrop' });
    },
    submitWallet() {
      this.$bvModal.hide('airdrop-event-win-modal');
      this.openSubmitModal();
    },
  },
};
</script>

<style lang="scss">
#airdrop-event-win-modal___BV_modal_outer_ {
  #airdrop-event-win-modal {
    .airdrop-event-win-modal {
      .modal-content {
        aspect-ratio: 1/1;
        border-radius: 15px;
        overflow: hidden;
        .modal-body {
          padding: 0;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
#airdrop-event-win {
  width: 100%;
  height: 100%;
  position: relative;

  img {
    &.fireworks {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      pointer-events: none;
      z-index: 0;
    }
    &.winner {
      padding: 10px;
      position: relative;
      top: 10%;
      transform: translateY(-10%);
      width: 100%;
      pointer-events: none;
      z-index: 1;
    }
  }
  button.go-to-regist {
    position: absolute;
    bottom: 5%;
    left: 50%;
    width: 80%;
    z-index: 2;
    font-weight: 400;
    font-size: 18px;
    transform: translate(-50%, -50%);
    background: #0e52d5;
    border-radius: 3px;
    color: #ffffff;
    height: clamp(42px, 4.2vw, 52px);
  }
}
</style>
